import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InputTypes } from 'app/shared/enums/input-types.enum';
import { LocalizedToasterService } from 'app/core/toaster/localized-toaster.service';
import { Location } from '@angular/common';
import { MergeAccountDataService } from 'app/shared/services/merge-account-data-service';
import { RouterService } from 'app/core/navigation';
import { catchError, tap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { TEACHERS_ROUTE } from 'app/teachers/teachers-routing.constant';

import { ValidationMessages } from 'app/shared/models/validation-messages.model';
import { untilDestroyed } from '@ngneat/until-destroy';
import { TranslationService } from 'app/core/internationalization/translation.service';

@Component({
    selector: 'kh-merge-teacher-form',
    styleUrls: ['./merge-teacher-form.component.less'],
    templateUrl: './merge-teacher-form.component.html',
    standalone: false
})
export class MergeTeacherFormComponent implements OnInit {
  public inputTypes = InputTypes;
  public credentialsForm!: FormGroup;
  public credentialsFormFields = {
    email: 'email',
    password: 'password'
  }

  public validationMessages: ValidationMessages = {
    required: this._translationService.instant('MERGE_TEACHER_FORM.THIS_FIELD_IS_REQUIRED'),
    invalid: this._translationService.instant('MERGE_TEACHER_FORM.INVALID_CREDENTIALS')
  };

  public constructor(
    private readonly formBuilder: FormBuilder,
    private readonly _translationService: TranslationService,
    private readonly mergeAccountDataService: MergeAccountDataService,
    private readonly routerService: RouterService,
    private readonly toaster: LocalizedToasterService,
    private readonly location: Location
  ) { }

  public ngOnInit(): void {

    this.credentialsForm = this.getCredentialsForm();
  }

  public getCredentialsForm(): FormGroup {
    return this.formBuilder.group({
      [this.credentialsFormFields.password]: this.formBuilder.control(undefined, Validators.required),
      [this.credentialsFormFields.email]: this.formBuilder.control(undefined, [Validators.required, Validators.email])
    });
  }

  public continue(): void {
    if (this.credentialsForm.valid) {
      const email = this.credentialsForm.value.email;
      const password = this.credentialsForm.value.password
      this.mergeAccountDataService
        .validateMergeCandidate(email, password)
        .pipe(
          tap( res => {
            if(res.canMerge) {
              this.routerService.navigate(TEACHERS_ROUTE.MERGE_ACCOUNT_SEND_EMAIL.route(),
                { queryParams: TEACHERS_ROUTE.MERGE_ACCOUNT_SEND_EMAIL.queryParams(res.displayName, res.email)});
            } else {
              this.toaster.error('MERGE_TEACHER_FORM.ACCOUNT_CANNOT_BE_MERGED');
              this.credentialsForm.reset();
            }
          }),
          catchError(error => {
            if(error.error.Errors.includes('Invalid credentials.')) {
              this.toaster.error(this.validationMessages['invalid']);
            }
            
            return EMPTY;
          })
        ).subscribe();
    }
  }

  public backButton(): void {
    this.location.back();
  }
}
